<style scoped>
@media print {
  @page {
    /* size: A5 landscape; */
    size: letter portrait;
    /* size: 9.5in 11in; */
    /* size: 241mm ; */
    margin: 10mm 5mm 5mm 5mm;
    /* size: 216mm 140mm; */
  }

  .page-break {
    page-break-before: always;
    counter-increment: pageCounter;
  }

  .page-counter::after {
    content: "Page " counter(pageCounter);
  }

  .footer,
  #non-printable {
    display: none !important;
  }

  #printable {
    display: block;
  }

  body {
    font-size: 100%;
  }

  table,
  td,
  th {
    font-size: 100%;
  }

  .page {
    page-break-after: always;
    counter-increment: pageCounter;
  }

  .page-footer {
    width: 100%;
    background-color: transparent !important;
    display: block;
    margin-top: auto;
  }
}

table {
  background-color: white !important;
  color: black !important;
}

table tr {
  font-family: "Courier";
  line-height: normal;
  font-size: 12px;
}

.text-bold {
  font-weight: bold;
}

.text-left {
  text-align: left;
}

.text-right {
  text-align: right;
}

.text-center {
  text-align: center;
}

#page-counter {
  display: table-footer-group;
}

.border-bottom {
  border-bottom: 1px dashed;
}

.text-align-top {
  vertical-align: top;
}
</style>

<template>
  <div>
    <div class="page-break" :key="idx" v-for="(data, idx) in datas">
      <table style="width: 100%">
        <thead>
          <tr>
            <td>
              <table width="100%" style="text-align: center; font-size: 14px">
                <tr>
                  <td><strong>HANDOVER</strong></td>
                </tr>
                <tr>
                  <td>
                    <strong>{{ data.company_name }}</strong>
                  </td>
                </tr>
              </table>
              <br />
              <table width="100%">
                <tr>
                  <td>Cabang</td>
                  <td>:</td>
                  <td>{{ data.warehouse_code }} {{ data.warehouse_name }}</td>
                  <td>Print</td>
                  <td>:</td>
                  <td>{{ data.print_counter }}</td>
                </tr>
                <tr>
                  <td>Shipment Number</td>
                  <td>:</td>
                  <td>
                    <nobr>{{ data.shipment_number }}</nobr>
                  </td>
                  <td>Print date</td>
                  <td>:</td>
                  <td>{{ dateNow }}</td>
                </tr>
                <tr>
                  <td>Tanggal Shipment</td>
                  <td>:</td>
                  <td>
                    <nobr>{{ formatDate(data.shipment_date) }}</nobr>
                  </td>
                  <td>Print time</td>
                  <td>:</td>
                  <td>{{ timeNow }}</td>
                </tr>

                <tr>
                  <td>Driver</td>
                  <td>:</td>
                  <td>
                    <nobr>{{ data.driver_name }}</nobr>
                  </td>
                  <td>Page</td>
                  <td>:</td>
                  <td>
                    {{ data.page }} of {{ data.totalPages }}
                  </td>
                </tr>
                <tr>
                  <td>Vehicle Number</td>
                  <td>:</td>
                  <td>
                    <nobr>{{ data.vehicle_number }}</nobr>
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </table>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div style="margin-top: 5px; border-top: 2px dashed;" v-if="data.lines.length == 0"></div>
              <table style="width: 100%" v-else>
                <thead>
                  <tr style="border-top: 2px dashed; border-bottom: 2px dashed">
                    <td class="text-left text-bold" style="width: 20%">
                      Customer
                    </td>
                    <td class="text-left text-bold" style="padding-left: 3px">
                      Item
                    </td>
                    <td class="text-left text-bold" style="width: 20%">
                      BATCH
                    </td>
                    <td class="text-left text-bold" style="width: 12%; padding-left: 3px">
                      ED
                    </td>
                    <td class="text-left text-bold" style="width: 5%; padding-left: 3px">
                      QTY
                    </td>
                    <td class="text-left text-bold" style="width: 5%; padding-left: 3px">
                      UOM
                    </td>
                  </tr>
                </thead>
                <div style="margin-top: 5px"></div>
                <tbody>
                  <template v-for="(tr, indexTr) in data.lines">
                    <template v-for="(tr2, indexTr2) in tr.do_line">
                      <template v-for="(tr3, indexTr3) in tr2.item_lines">
                        <template v-for="(tr4, indexTr4) in tr3.rows">
                          <tr
                            :class="`outerTable-${indexTr}-${indexTr2}-${indexTr3}-${indexTr4}`"
                            v-bind:key="`outerTable-${indexTr}-${indexTr2}-${indexTr3}-${indexTr4}`"
                          >
                            <td
                              v-if="tr.customerVisual[tr4.customer_visual_index]"
                              :class="customClass(indexTr2, indexTr3, indexTr4, tr.do_line.length, tr2.item_lines.length, tr3.rows.length)"
                            >
                              {{ tr.customerVisual[tr4.customer_visual_index].view }}
                            </td>
                            <!-- <td
                              v-if="indexTr4 == 0 && indexTr3 == 0 && indexTr2 == 0"
                              class="py-1 text-align-top"
                            >
                              {{ tr.customerVisual[indexTr4].view }}
                            </td>
                            <td
                              v-else-if="indexTr4 == tr3.rows.length-1 && indexTr3 == tr2.item_lines.length-1 && indexTr2 == tr.do_line.length-1 && indexTr4 == 0 && indexTr3 == 0 && indexTr2 == 0"
                              class="py-1 text-align-top border-bottom"
                            >
                              {{ tr.customerVisual[tr4.customer_visual_index].view }}
                            </td>
                            <td
                              v-else-if="indexTr4 == tr3.rows.length-1 && indexTr3 == tr2.item_lines.length-1 && indexTr2 == tr.do_line.length-1"
                              class="py-1 text-align-top border-bottom"
                            ></td> -->
                            <td v-else :class="customClass(indexTr2, indexTr3, indexTr4, tr.do_line.length, tr2.item_lines.length, tr3.rows.length)"></td>
                            <td :class="indexTr4 == tr3.rows.length-1 ? 'py-1 border-bottom' : 'py-1'">
                              {{ tr4.visual_item_name }}
                            </td>
                            <td :class="indexTr4 == tr3.rows.length-1 ? 'py-1 border-bottom' : 'py-1'">
                              {{ tr4.visual_batch_external }}
                            </td>
                            <td :class="indexTr4 == tr3.rows.length-1 ? 'py-1 border-bottom' : 'py-1'">
                              {{ tr4.expired_date !== '' ? formatDate(tr4.expired_date) : '' }}
                            </td>
                            <td :class="indexTr4 == tr3.rows.length-1 ? 'py-1 border-bottom' : 'py-1'" style="padding-left: 5px">
                              {{ tr4.amount }}
                            </td>
                            <td :class="indexTr4 == tr3.rows.length-1 ? 'py-1 border-bottom' : 'py-1'">
                              {{ tr4.unit }}
                            </td>
                          </tr>
                        </template>
                      </template>
                    </template>
                  </template>
                </tbody>
              </table>
              <div
                class="page-footer"
                v-if="data.isSignature"
              >
                <template v-for="index in getBlankRows(data)">
                  <tr :key="'blank-'+index">
                    <td class="py-1">&nbsp;</td>
                  </tr>
                </template>
                <table style="width: 100%">
                  <tr>
                    <th style="text-align: center">Diserahkan oleh</th>
                    <th style="text-align: center">Diterima oleh</th>
                    <th style="text-align: center">Diketahui oleh</th>
                  </tr>
                  <tr>
                    <th style="height: 50px"></th>
                    <th style="height: 50px"></th>
                    <th style="height: 50px"></th>
                  </tr>
                  <tr>
                    <th style="text-align: center">Checker</th>
                    <th style="text-align: center">Driver</th>
                    <th style="text-align: center">SPV Logistic</th>
                  </tr>
                </table>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";

export default {
  name: "PrintPdf",
  data() {
    return {
      id: null,
      handoverIds: null,
      datas: [],
      dateNow: "",
      timeNow: "",
      maxItemsPerPage: 35,
      maxCharCustomerPerLine: 19,
      maxCharItemsPerLine: 35,
      maxCharBatchPerLine: 18,
    };
  },
  mounted() {
    this.handoverIds = window.opener.handoverIds;
    if (this.handoverIds.length) {
      this.print();
    }
  },
  methods: {
    async print() {
      await this.getData();
      const tempTitle = document.title;
      await window.print();
      document.title = tempTitle;
    },
    async getData() {
      this.$vs.loading();
      let resp = await this.$http.get(
        `/api/wms/v1/simple-outbound-processing/print-handover`,
        { params: { handover_ids: this.handoverIds, is_print: 1 } }
      );
      if (resp.code == 200) {
        let datas = resp.data;

        document.title = datas.reduce(
          (prev, curr) => `${prev}-${curr.shipment_number}`,
          "HANDOVER"
        );

        const paginatedData = [];
        const totalPagesMap = {};

        // First pass: Calculate total pages for each shipment_number
        /* datas.forEach((data) => {
          let currentItemCount = 0;
          let pageCount = 0;

          const dataLines = this.prepareWrappedData(data.lines)

          dataLines.forEach((line) => {
            line.do_line.forEach((doLine) => {
              let itemOffset = 0;
              let usedLineCounts = 0;

              doLine.visualSummaries.forEach(tr3 => {
                usedLineCounts += tr3.count
              })

              while (itemOffset < doLine.item_lines.length) {
                const remainingSpace = this.maxItemsPerPage - currentItemCount;
                const itemsToTake = Math.min(remainingSpace, usedLineCounts - itemOffset);

                currentItemCount += itemsToTake;
                itemOffset += itemsToTake;

                // When page limit is reached, count the page and reset item count
                if (currentItemCount === this.maxItemsPerPage) {
                  pageCount++;
                  currentItemCount = 0;
                }
              }
            });
          });

          // Count the last page if it has remaining items
          if (currentItemCount >= 0) {
            pageCount++;
          }

          // Store total page count for this shipment_number
          totalPagesMap[data.shipment_number] = pageCount;
        }); */

        // Second pass: Create paginated data with shared totalPages for each shipment_number
        datas.forEach((data) => {
          let currentPageNumber = 0;
          let currentPage = {
            ...data,
            lines: [],
            isSignature: false,
            page: currentPageNumber,
            totalPages: 0,
            totalItems: 0
          };
          let currentItemCount = 0;

          const dataLines = this.prepareWrappedData(data.lines)

          dataLines.forEach((line) => {
            let lineCopy = { ...line, do_line: [] };
            let customerVisualIndex = 0
            let greaterCustomerVisual = false
            let visualLineCount = 0
            let deltaVisual = 0

            line.do_line.forEach(doLine => {
              doLine.visualSummaries.forEach(tr3 => {
                visualLineCount += tr3.count
              })
            })

            if (line.customerVisual.length > visualLineCount) {
              greaterCustomerVisual = true
              deltaVisual = line.customerVisual.length - visualLineCount
            }

            line.do_line.forEach((doLine) => {
              let itemOffset = 0;
              let usedLineCounts = 0;

              doLine.visualSummaries.forEach(tr3 => {
                usedLineCounts += tr3.count
              })

              if (greaterCustomerVisual) {
                usedLineCounts = line.customerVisual.length
              }

              while (itemOffset < doLine.item_lines.length) {
                const remainingSpace = this.maxItemsPerPage - currentItemCount;
                const itemsToTake = Math.min(remainingSpace, usedLineCounts - itemOffset);
                let availableToTake = 0
                let usedCount = 0
                let createNewPage = false

                if (greaterCustomerVisual) {
                  usedCount += deltaVisual
                }

                for (let i = itemOffset; i < doLine.visualSummaries.length; i++) {
                  const visualData = doLine.visualSummaries[i]

                  if (usedCount + visualData.count > itemsToTake) {
                    createNewPage = true
                    break
                  }

                  usedCount += visualData.count
                  availableToTake++

                  visualData.rows.forEach(row => {
                    row.customer_visual_index = customerVisualIndex
                    customerVisualIndex++
                  })
                }

                if (availableToTake > 0) {
                  const itemChunk = doLine.visualSummaries.slice(itemOffset, itemOffset + availableToTake);

                  doLine.item_lines.slice(itemOffset, itemOffset + availableToTake)

                  const doLineCopy = { ...doLine, item_lines: itemChunk };

                  lineCopy.do_line.push(doLineCopy);

                  currentItemCount += usedCount;
                  itemOffset += availableToTake;
                }

                // When page limit is reached, create a new page
                if (currentItemCount === this.maxItemsPerPage || createNewPage) {
                  currentPage.lines.push(lineCopy);
                  currentPage.page = ++currentPageNumber;
                  currentPage.totalItems += currentItemCount
                  paginatedData.push(currentPage);

                  // Reset for the new page
                  currentPage = {
                    ...data,
                    lines: [],
                    isSignature: false,
                    page: currentPageNumber,
                    totalPages: 0,
                    totalItems: 0,
                  };
                  lineCopy = { ...line, do_line: [] };
                  currentItemCount = 0;
                  customerVisualIndex = 0;
                }
              }
            });

            if (lineCopy.do_line.length > 0) {
              currentPage.lines.push(lineCopy);
            }
          });

          // Add the last page if it has remaining items and set isSignature to true if it's the final page
          if (currentItemCount >= 0) {
            currentPage.page = ++currentPageNumber;
            currentPage.isSignature = currentItemCount < this.maxItemsPerPage;
            currentPage.totalItems += currentItemCount

            if (currentItemCount == 0) {
              currentPage.lines = [];
            }

            paginatedData.push(currentPage);
          }

          totalPagesMap[data.shipment_number] = currentPageNumber
        });

        paginatedData.forEach(data => {
          data.totalPages = totalPagesMap[data.shipment_number]

          data.lines.forEach(line => {
            let itemLineGlobalIndex = 0
            let totalItems = 0

            line.do_line.forEach(doLine => {
              doLine.item_lines.forEach(item => {
                item.rows.forEach(row => {
                  itemLineGlobalIndex = row.customer_visual_index
                  totalItems++
                })
              })
            })

            if (totalItems < line.customerVisual.length) {
              let count = 0
              let rows = []
              let customer_visual_length = line.customerVisual.length - totalItems

              for (let i = 0; i < customer_visual_length; i++) {
                count++
                itemLineGlobalIndex++

                rows.push({
                  sku_code: "",
                  expired_date: "",
                  amount: "",
                  unit: "",
                  item_name: "",
                  batch_external: "",
                  visual_item_name: "",
                  visual_batch_external: "",
                  customer_visual_index: itemLineGlobalIndex,
                })
              }

              for (let i = 0; i < line.do_line.length; i++) {
                if (i == line.do_line.length-1) {
                  const doLine = line.do_line[i]

                  doLine.item_lines.push({
                    count,
                    rows,
                  })
                }
              }
            }
          })
        })

        this.datas = paginatedData
        this.dateNow = moment().format("DD/MM/YYYY");
        this.timeNow = moment().format("HH:mm:ss");
        this.$vs.loading.close();
      } else {
        this.$vs.loading.close();
      }
    },
    calculateWrappedLines(text, maxCharPerLine) {
      if (!text) return 1

      return Math.ceil(text.length / maxCharPerLine)
    },
    getRowLines(tr, tr3, customers) {
      const customer = `${tr.customer_code || ''} ${tr.customer_name || ''}`
      const item = `${tr3.sku_code || ''} ${tr3.item_name || ''}`
      const batch = `${tr3.batch_external || ''}`

      let customerLines = 1
      if (!customers.has(customer)) {
        customers.add(customer)
        customerLines = this.calculateWrappedLines(customer, this.maxCharCustomerPerLine)
      }

      const itemLines = this.calculateWrappedLines(item, this.maxCharItemsPerLine)
      const batchLines = this.calculateWrappedLines(batch, this.maxCharBatchPerLine)

      return Math.max(
        customerLines,
        itemLines,
        batchLines
      )
    },
    getTotalVisualLines(data) {
      let total = 0

      data.lines.forEach(tr => {
        tr.do_line.forEach(tr2 => {
          tr2.item_lines.forEach(tr3 => {
            total += tr3.count
          })
        })
      })

      return total
    },
    getBlankRows(data) {
      let totalVisualLines = this.getTotalVisualLines(data)

      const blankRows = this.maxItemsPerPage - totalVisualLines

      return blankRows > 0 ? blankRows : 0
    },
    splitCustomerNameItemName(text, maxLength) {
      if (!text) return [""];

      const words = text.trim().split(/\s+/);
      const lines = [];
      let currentLine = "";

      words.forEach(word => {
        const nextLine = currentLine
          ? `${currentLine} ${word}`
          : word;

        if (nextLine.length <= maxLength) {
          currentLine = nextLine;
        } else {
          if (currentLine) {
            lines.push(currentLine);
          }

          // jika ada 1 kata lebih panjang dari maxLength
          if (word.length > maxLength) {
            for (let i = 0; i < word.length; i += maxLength) {
              lines.push(word.substring(i, i + maxLength));
            }
            currentLine = "";
          } else {
            currentLine = word;
          }
        }
      });

      if (currentLine) {
        lines.push(currentLine);
      }

      return lines;
    },
    splitBatch(text, maxLength) {
      if (!text) return [""];

      if (text.length <= maxLength) {
        return [text];
      }

      // pisahkan menjadi token beserta separatornya
      const tokens = text.match(/[^\-./\s]+|[-./]|\s+/g);

      const lines = [];
      let current = "";

      tokens.forEach(token => {
        const next = current + token;

        if (next.length <= maxLength) {
          current = next;
        } else {
          if (current) {
            lines.push(current.trimEnd());
          }

          // jika token sendiri terlalu panjang
          if (token.trim().length > maxLength) {
            const value = token.trim();

            for (let i = 0; i < value.length; i += maxLength) {
              lines.push(value.substring(i, i + maxLength));
            }

            current = "";
          } else {
            current = token.trimStart();
          }
        }
      });

      if (current) {
        lines.push(current.trimEnd());
      }

      return lines;
    },
    prepareWrappedData(dataLines) {
      return dataLines.map(tr => {
        const customer = `${tr.customer_code || ''} ${tr.customer_name || ''}`
        const customerVisual = []

        const customerLines = this.splitCustomerNameItemName(customer, this.maxCharCustomerPerLine)
        for (let i = 0; i < customerLines.length; i++) {
          customerVisual.push({
            view: customerLines[i] || "",
          })
        }

        const do_line = tr.do_line.map(tr2 => {
          const visualSummaries = []

          tr2.item_lines.forEach(tr3 => {
            const item = `${tr3.sku_code || ''} ${tr3.item_name || ''}`
            const batch = `${tr3.batch_external || ''}`

            const itemLines = this.splitCustomerNameItemName(item, this.maxCharItemsPerLine)
            const batchLines = this.splitBatch(batch, this.maxCharBatchPerLine)
            const maxLines = Math.max(itemLines.length, batchLines.length)
            const rows = []

            for (let i = 0; i < maxLines; i++) {
              rows.push({
                ...tr3,
                sku_code: i === 0 ? tr3.sku_code : "",
                expired_date: i === 0 ? tr3.expired_date : "",
                amount: i === 0 ? tr3.amount : "",
                unit: i === 0 ? tr3.unit : "",
                item_name: i === 0 ? tr3.item_name : "",
                batch_external: i === 0 ? tr3.batch_external : "",
                visual_item_name: itemLines[i] || "",
                visual_batch_external: batchLines[i] || "",
                customer_visual_index: 0,
              })
            }

            visualSummaries.push({
              rows,
              count: maxLines,
            })
          })

          return {
            ...tr2,
            visualSummaries
          }
        })

        return {
          ...tr,
          customerVisual,
          do_line,
        }
      })
    },
    customClass(index2, index3, index4, length2, length3, length4) {
      let rowClass = "py-1 text-align-top"

      if (index2 == 0 && index3 == 0 && index4 == 0 && index2 == length2-1 && index3 == length3-1 && index4 == length4-1) {
        rowClass = "py-1 text-align-top border-bottom"
      } else if (index2 == length2-1 && index3 == length3-1 && index4 == length4-1) {
        rowClass = "py-1 text-align-top border-bottom"
      }

      return rowClass
    },
  },
  computed: {
    formatDate: () => {
      return (val) => {
        const momentDate = moment(val);
        return momentDate.format("DD/MM/YYYY");
      };
    },
    formatTime: () => {
      return (val) => {
        const momentDate = moment(val).local();
        return momentDate.format("hh:mm:ss");
      };
    },
  },
};
</script>
